import { convertQuotas } from '@aytm/app/stats/lib/query/traits'

const smart_time = t => {
  if (!t) return '0 seconds'
  const m = parseInt(t / 60, 10)
  const s = parseInt(t - m * 60, 10)
  const mm = 10 > m ? `0${m}m:` : `${m}m:`
  return 10 > s ? `${mm}0${s}s` : `${mm}${s}s`
}

export const renderProps = (survey, model) => {
  const props = {}

  const totals = model.totals || {}
  const target_market = survey.target_market || {}

  props.respondents = target_market.respondents
  props.video_respondents = target_market.video_respondents
  props.research_type = target_market.research_type

  props.tags = target_market.tags || []

  props.totalRespondents = totals.totalRespondents || 0
  props.totalVideoResponses = totals.totalVideoResponses || 0

  if (model.isExternalSurvey) {
    const surveyCompletionTime = totals.surveyCompletionTime || {}

    props.completion_times ||= {}
    if (0 < Object.keys(surveyCompletionTime).length) {
      props.completion_times.shortest = smart_time(surveyCompletionTime.min)
      props.completion_times.mean = smart_time(surveyCompletionTime.mean)
      props.completion_times.median = smart_time(surveyCompletionTime.median)
      props.completion_times.longest = smart_time(surveyCompletionTime.max)
    } else {
      props.completion_times.shortest = '0 seconds'
      props.completion_times.mean = '0 seconds'
      props.completion_times.median = '0 seconds'
      props.completion_times.longest = '0 seconds'
    }

    props.totalPartialResponses = totals.totalPartialResponses || 0
    props.totalFailedPrequalsResponses = totals.totalFailedPrequalsResponses || 0
    props.totalOeRejectedResponses = totals.totalOeRejectedResponses || 0
  } else {
    props.quotas = convertQuotas(survey) || []
    props.quotaType = target_market.quotaType
    props.option_include = target_market.option_include || {}
    props.option_exclude = target_market.option_exclude || {}
    props.custom_quotas = target_market.customQuotas || []
  }

  props.legalCompliance =
    (Object.hasOwn(survey, 'legalCompliance') &&
      Object.entries(survey.legalCompliance).map(([key, link]) => {
        return { locale: key.split('_', 1)[0].toUpperCase(), link }
      })) ||
    []

  return props
}
